import { Container, Header, Button } from '@cloudscape-design/components'
import { FC } from 'react'
import { useNavigate } from 'react-router-dom'

interface ProjectResourcesPanelProps {
	resources: Array<{ relativePath: string; description: string }>
}

const ProjectResourcePanel: FC<ProjectResourcesPanelProps> = ({
	resources
}) => {
	const navigate = useNavigate()

	const items = resources.map((resources) => (
		<Button
			variant="link"
			onClick={() => navigate(resources.relativePath, { relative: 'path' })}
		>
			{resources.description}
		</Button>
	))

	return (
		<Container header={<Header variant="h3">Infrastructure Resources</Header>}>
			{items}
		</Container>
	)
}

export default ProjectResourcePanel
